/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends {
    [key: string]: unknown;
}> = {
    [K in keyof T]: T[K];
};
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | {
    [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
};
//@ts-nocheck TS6133
/* eslint-disable @typescript-eslint/no-duplicate-imports */
import type { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type GetSectionsPlacesQueryVariables = Exact<{
    query?: string | null | undefined;
}>;
export type GetSectionsPlacesQuery = {
    sections: {
        __typename: "FindPlacesResponse";
        sections: Array<{
            __typename: "Place";
            id: string;
            name: string;
            floorId: string | null;
            images: Array<{
                __typename: "Link";
                name: string;
                value: string;
            } | null> | null;
        } | null> | null;
    } | null;
};
export const GetSectionsPlacesDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetSectionsPlaces" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "query" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": { "kind": "Name", "value": "sections" }, "name": { "kind": "Name", "value": "places" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "request" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "query" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "query" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": { "kind": "Name", "value": "sections" }, "name": { "kind": "Name", "value": "places" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "alias": { "kind": "Name", "value": "floorId" }, "name": { "kind": "Name", "value": "parentId" } }, { "kind": "Field", "name": { "kind": "Name", "value": "images" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "value" } }] } }] } }] } }] } }] } as unknown as DocumentNode<GetSectionsPlacesQuery, GetSectionsPlacesQueryVariables>;
